// opervex-frontend/src/Opervex/MaterialManagement/GoodsMovement.js

import { SearchHelpModal } from "../../utils/SearchHelp";

class GoodsMovement {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findId(id) {
    return await this.#_api.get("/MaterialManagement/GoodsMovement/" + id);
  }

  async getPDF(id) {
    return await this.#_api.getBinary("/MaterialManagement/GoodsMovement/" + id + "/PDF");
  }

  async update(id, data) {
    return this.#_api.put("/MaterialManagement/GoodsMovement/" + id, data);
  }

  async reversal(id, data) {
    return this.#_api.post(`/MaterialManagement/GoodsMovement/${id}/Reversal`, data);
  }

  async create(data) {
    return this.#_api.post("/MaterialManagement/GoodsMovement/", data);
  }

  async SearchHelpModal({ documentDate } = {}) {
    const preFilters = [];

    if (documentDate) preFilters.push({ operation: "AND", operator: ">=", fieldname: "documentDate", value: documentDate });

    const parameters = {
      url: "/MaterialManagement/GoodsMovement/SearchHelp",
      preFilters,
      schema: await this.schema(),
    };

    const item = await SearchHelpModal({
      urlData: parameters.url,
      preFilters: parameters.preFilters,
      schema: parameters.schema,
    });

    return item;
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "operation",
        label: "Operação",
        type: "string",
        visible: true,
        hidden: false,
        style: {
          align: "left",
        },
      },
      {
        key: "documentDate",
        label: "Data do Documento",
        type: "dateOnly",
        visible: true,
        hidden: false,
      },
      {
        key: "reference",
        label: "Referência",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "reversal",
        label: "Estorno",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default GoodsMovement;
